import { ArrowRightIcon } from "@eventbrite/marmalade"
import classNames from "classnames"
import { FC, MouseEventHandler } from "react"
import Recommended from "../RecommendedBadge/Recommended"
import * as styles from "./SupportWidget.module.scss"

type Props = {
  primaryText: React.ReactNode
  icon: React.ReactNode
  secondaryText?: React.ReactNode
  classes?: string
  recommended?: boolean
  clickHandler?: MouseEventHandler
  tabIndex?: number
  order?: number
}

const SupportWidget: FC<Props> = ({
  primaryText,
  secondaryText,
  icon,
  classes,
  recommended,
  clickHandler,
  tabIndex = 0,
  order = 0
}) => {
  return (
    <div
      tabIndex={tabIndex}
      style={{ order }}
      onClick={clickHandler}
      className={classNames(styles.widgetWrapper, classes)}
    >
      <div className={styles.innerContainer}>
        <div className={styles.iconContainer}>
          <div className={styles.iconWrapper}>{icon}</div>
        </div>
        <div className={styles.textSection}>
          <div className={styles.headerContainer}>
            <h4 className={styles.primary}>{primaryText}</h4>
            {recommended && <Recommended />}
          </div>
          {secondaryText ? (
            <h5 className={styles.secondary}>{secondaryText}</h5>
          ) : null}
        </div>
        <div className={styles.arrowIconWrapper}>
          <ArrowRightIcon />
        </div>
      </div>
    </div>
  )
}

export default SupportWidget
